import { PromotionMensualisationSecurityDto } from './dtos/promotion-mensualisation-security.dto';
import { axiosCore } from './http-core-service';

export const promotionMensualisationAuth = async (
    token: string | null,
    data: PromotionMensualisationSecurityDto
): Promise<any> => {
    const response = await axiosCore.post(`/promotion_mensualisation/auth/${token}`, data);

    return response.data;
};
